<template>
  <div id="app" v-cloak>
    <v-app>
      <div class="page-wrap">

        <!-- ══════════════════════ HEADER ══════════════════════ -->
        <div class="header-card">

          <!-- Esquerda: ícone + título + data -->
          <div class="header-left">
            <div class="header-icon">
              <v-icon size="24" style="color:#2563eb">mdi-calendar-check-outline</v-icon>
            </div>
            <div>
              <h1 class="page-title">Aberturas de Expediente</h1>
              <div class="page-date">
                <v-icon size="13">mdi-clock-outline</v-icon>
                {{ dataAtualFormatada }}
              </div>
              <div style="font-size: 0.65rem; color: #1e3a8a; margin-top: 2px;">
                Desenvolvido por Tabosa Sistemas
              </div>
            </div>
          </div>

          <!-- Direita: 3 stat pills + botão refresh -->
          <div class="header-right">
            <!-- Total de registros -->
            <div class="stat-pill">
              <div class="stat-pill-icon blue">
                <v-icon size="17" style="color:#2563eb">mdi-database-outline</v-icon>
              </div>
              <div class="stat-pill-body">
                <span class="stat-pill-label">Registros</span>
                <span class="stat-pill-value">{{ total }}</span>
              </div>
            </div>

            <!-- Filtros ativos -->
            <div class="stat-pill">
              <div class="stat-pill-icon purple">
                <v-icon size="17" style="color:#7c3aed">mdi-filter-check-outline</v-icon>
              </div>
              <div class="stat-pill-body">
                <span class="stat-pill-label">Filtros Ativos</span>
                <span class="stat-pill-value">{{ filtrosAtivos }}</span>
              </div>
            </div>

            <!-- Última seleção -->
            <div class="stat-pill">
              <div class="stat-pill-icon teal">
                <v-icon size="17" style="color:#0891b2">mdi-cursor-default-click-outline</v-icon>
              </div>
              <div class="stat-pill-body">
                <span class="stat-pill-label">Última Seleção</span>
                <span class="stat-pill-value small">{{ ultimaSelecaoLabel }}</span>
              </div>
            </div>

            <!-- Voltar -->
            <v-btn
              icon="mdi-arrow-left"
              variant="text"
              class="btn-back"
              @click="voltarMenu"
            />

            <!-- Refresh -->
            <v-btn
              icon="mdi-refresh"
              variant="text"
              class="btn-refresh"
              :loading="loading"
              @click="carregarAberturas"
            />

          </div>
        </div>

        <!-- ════════════════════════ FILTROS ════════════════════════ -->
        <div class="filters-card">
          <div class="filters-title">
            <v-icon size="17" style="color:#2563eb">mdi-filter-variant</v-icon>
            Filtros de busca
          </div>

          <v-row dense>
            <!-- ID -->
            <v-col cols="12" md="2">
              <v-text-field
                v-model="filters.id"
                label="ID"
                density="compact"
                variant="outlined"
                hide-details
                @keyup.enter="buscar"
              />
            </v-col>

            <!-- Setor -->
            <v-col cols="12" md="3">
              <v-select
                v-model="filters.setor_id"
                :items="setores"
                item-title="descricao_setor"
                item-value="setor_id"
                label="Setor"
                density="compact"
                variant="outlined"
                clearable
                hide-details
              />
            </v-col>

            <!-- Chefe -->
            <v-col cols="12" md="3">
              <v-select
                v-model="filters.chefe_id"
                :items="chefes"
                item-title="nome"
                item-value="chefe_id"
                label="Chefe"
                density="compact"
                variant="outlined"
                clearable
                hide-details
              />
            </v-col>

            <!-- Período -->
            <v-col cols="12" md="2">
              <v-select
                v-model="filters.periodo"
                :items="periodos"
                item-title="label"
                item-value="value"
                label="Período"
                density="compact"
                variant="outlined"
                clearable
                hide-details
                @update:model-value="onPeriodoChange"
              />
            </v-col>

            <!-- Buscar -->
            <v-col cols="12" md="1">
              <v-btn
                block
                class="btn-primary"
                prepend-icon="mdi-magnify"
                :loading="loading"
                @click="buscar"
              >
              </v-btn>
            </v-col>

            <!-- Limpar -->
            <v-col cols="12" md="1">
              <v-btn
                block
                class="btn-danger"
                prepend-icon="mdi-eraser"
                @click="limparBusca"
              >
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- ════════════════════════ DIALOG PERÍODO CUSTOM ════════════════════════ -->
        <v-dialog v-model="dialogPeriodo" max-width="440">
          <v-card style="border-radius:16px; border:1px solid #e2e8f0;">
            <v-card-title class="d-flex align-center pa-5" style="color:#1e293b; font-weight:600;">
              <v-icon class="me-2" style="color:#2563eb">mdi-calendar-range</v-icon>
              Período Personalizado
            </v-card-title>
            <v-card-text class="pa-5 pt-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="periodoCustom.data_inicio"
                    type="date"
                    label="Data inicial"
                    density="comfortable"
                    variant="outlined"
                    prepend-inner-icon="mdi-calendar-start"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="periodoCustom.data_fim"
                    type="date"
                    label="Data final"
                    density="comfortable"
                    variant="outlined"
                    prepend-inner-icon="mdi-calendar-end"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pa-5 pt-0">
              <v-spacer />
              <v-btn
                class="btn-danger"
                prepend-icon="mdi-close"
                @click="dialogPeriodo = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="btn-primary ms-2"
                prepend-icon="mdi-check"
                @click="aplicarPeriodoCustom"
              >
                Aplicar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ════════════════════════ DIALOG PREVIEW ════════════════════════ -->
        <v-dialog v-model="dialogPreview" max-width="1200px" max-height="90vh">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-btn icon @click="voltarMenu" class="mr-2">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-icon class="mr-2">mdi-printer-eye</v-icon>
              Preview de Impressão
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogPreview=false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn
                class="ml-2"
                color="white"
                prepend-icon="mdi-printer"
                @click="imprimirIframe"
              >
                Imprimir
              </v-btn>
            </v-toolbar>
            <v-card-text style="padding:0; overflow: hidden;">
              <iframe
                ref="iframePreview"
                :src="previewUrl"
                style="width:100%; height:70vh; border:none; display:block;"
              ></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ════════════════════════ LOADING PREVIEW ════════════════════════ -->
        <v-dialog 
          v-model="loadingPreview" 
          persistent 
          width="400"
          content-class="loading-preview-dialog"
        >
          <v-card class="loading-card">
            <v-card-text class="pa-6 text-center">
              <v-icon size="48" color="primary" class="mb-4">mdi-eye-outline</v-icon>
              <h3 class="text-h5 mb-2">Carregando Preview</h3>
              <p class="text-body-2 text-grey-darken-1 mb-4">
                Aguarde enquanto carregamos o relatório para visualização...
              </p>
              <v-progress-linear 
                indeterminate 
                color="primary"
                height="4"
                class="mb-2"
              ></v-progress-linear>
              <p class="text-caption text-grey-darken-2">
                Isso pode levar alguns segundos
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ════════════════════════ LOADING IMPRESSÃO ════════════════════════ -->
        <v-dialog 
          v-model="loadingImpressao" 
          persistent 
          width="400"
          content-class="loading-impressao-dialog"
        >
          <v-card class="loading-card">
            <v-card-text class="pa-6 text-center">
              <v-icon size="48" color="primary" class="mb-4">mdi-printer</v-icon>
              <h3 class="text-h5 mb-2">Gerando Relatório</h3>
              <p class="text-body-2 text-grey-darken-1 mb-4">
                Aguarde enquanto preparamos seu relatório para impressão...
              </p>
              <v-progress-linear 
                indeterminate 
                color="primary"
                height="4"
                class="mb-2"
              ></v-progress-linear>
              <p class="text-caption text-grey-darken-2">
                Isso pode levar alguns segundos
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ══════════════════════════ TABELA ════════════════════════ -->
        <div class="table-card">
          <v-data-table-server
            density="compact"
            :headers="headers"
            :items="aberturas"
            :loading="loading"
            :items-length="total"
            :page="currentPage"
            :items-per-page="itemsPerPage"
            item-value="id"
            @update:options="onOptionsChange"
          >
            <!-- Data Abertura -->
            <template #item.data_abertura="{ item }">
              {{ formatDate(item.data_abertura) }}
            </template>

            <!-- Data Encerramento -->
            <template #item.data_encerramento="{ item }">
              {{ formatDate(item.data_encerramento) }}
            </template>

            <!-- Status chip -->
            <template #item.status="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                size="small"
                variant="flat"
              >
                {{ item.status }}
              </v-chip>
            </template>

            <!-- Ações -->
            <template #item.actions="{ item }">
              <v-btn
                size="small"
                class="btn-primary"
                variant="flat"
                prepend-icon="mdi-printer"
                @click="preview(item)"
              >
                Imprimir
              </v-btn>
            </template>
          </v-data-table-server>
        </div>

        <!-- ════════════════════════ FOOTER ════════════════════════ -->
        <div class="page-footer mono">
          Total: <strong>{{ total }}</strong> registros
          &bull; Página <strong>{{ currentPage }}</strong> de <strong>{{ totalPaginas }}</strong>
          &bull; Última seleção: <strong>{{ ultimaSelecaoLabel }}</strong>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'RelatorioFiltroOriginalPage',
  
  data() {
    return {
      dialogPreview: false,
      previewUrl: '',
      listaEndpoint: '/api/api_aberturas.php',
      reportUrl: '/relatorios/rel_expidente_2026.php',

      aberturas: [],
      total: 0,
      currentPage: 1,
      itemsPerPage: 10,
      loading: false,
      loadingImpressao: false,
      loadingPreview: false,

      setores: [],
      chefes: [],

      filters: {
        id: '',
        setor_id: null,
        chefe_id: null,
        periodo: null,
        data_inicio: '',
        data_fim: ''
      },

      dialogPeriodo: false,
      periodoCustom: { data_inicio: '', data_fim: '' },

      periodos: [
        { label: 'Hoje', value: 'hoje' },
        { label: 'Ontem', value: 'ontem' },
        { label: 'Esta semana', value: 'semana_atual' },
        { label: 'Semana passada', value: 'semana_passada' },
        { label: 'Últimos 15 dias', value: '15_dias' },
        { label: 'Este mês', value: 'mes_atual' },
        { label: 'Período personaliz.', value: 'custom' }
      ],

      headers: [
        { title: 'ID', key: 'id', sortable: true, width: '70px' },
        { title: 'Setor', key: 'descricao_setor', sortable: true },
        { title: 'Chefe', key: 'nome', sortable: true },
        { title: 'Abertura', key: 'data_abertura', sortable: true },
        { title: 'Encerramento', key: 'data_encerramento', sortable: true },
        { title: 'Status', key: 'status', sortable: true, width: '130px' },
        { title: 'Ações', key: 'actions', sortable: false, width: '120px' }
      ],

      ultimaSelecao: null
    }
  },

  computed: {
    dataAtualFormatada() {
      return new Date().toLocaleDateString('pt-BR', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
      })
    },

    filtrosAtivos() {
      const { id, setor_id, chefe_id, periodo, data_inicio, data_fim } = this.filters
      return [id, setor_id, chefe_id, periodo, data_inicio, data_fim]
        .filter(v => v !== null && v !== '' && v !== undefined)
        .length
    },

    ultimaSelecaoLabel() {
      if (!this.ultimaSelecao) return 'Nenhuma'
      return `#${this.ultimaSelecao.id ?? '?'} · ${this.ultimaSelecao.descricao_setor ?? '--'}`
    },

    totalPaginas() {
      if (!this.total || !this.itemsPerPage) return 1
      return Math.ceil(this.total / this.itemsPerPage)
    }
  },

  methods: {
    voltarMenu() {
      this.$router.push('/menu/dashboard')
    },
    
    imprimirIframe() {
      // Mostrar loading de impressão
      this.loadingImpressao = true
      
      const iframe = this.$refs.iframePreview
      if (!iframe) {
        this.loadingImpressao = false
        return
      }
      
      // Aguardar um pouco para mostrar o loading
      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
        
        // Fechar loading após impressão
        setTimeout(() => {
          this.loadingImpressao = false
        }, 2000)
      }, 500)
    },

    preview(item) {
      console.log('Preview chamado para item:', item)
      
      // Mostrar loading de preview
      this.loadingPreview = true
      
      if (!item?.id) { 
        console.error('ID não encontrado no item:', item)
        this.loadingPreview = false
        alert('ID não encontrado.')
        return 
      }
      
      console.log('ID encontrado:', item.id)
      this.ultimaSelecao = item

      const sep = this.reportUrl.includes('?') ? '&' : '?'
      const p = new URLSearchParams({
        id_abertura: String(item.id ?? ''),
        data_abertura: item.data_abertura ?? '',
        data_encerramento: item.data_encerramento ?? '',
        chefe: item.nome ?? '',
        setor: item.descricao_setor ?? '',
        status: item.status ?? ''
      })

      this.previewUrl = `${this.reportUrl}${sep}${p.toString()}`
      console.log('Preview URL gerada:', this.previewUrl)
      
      this.dialogPreview = true
      console.log('Dialog preview aberto')
      
      // Esconder loading após abrir o dialog
      setTimeout(() => {
        this.loadingPreview = false
      }, 1000)
    },

    async carregarFiltros() {
      console.log('Iniciando carregarFiltros')
      try {
        // Simples loading sem depender de $root
        const res = await fetch(`${this.listaEndpoint}?limit=0`)
        const json = await res.json()
        this.setores = json.setores ?? []
        this.chefes = json.chefes ?? []
        
        console.log('Filtros carregados:', { setores: this.setores.length, chefes: this.chefes.length })
        
        if (!this.setores.length) {
          console.warn('Nenhum setor ou chefe encontrado')
          alert('Nenhum setor ou chefe encontrado.')
        }
      } catch (e) {
        console.error('Erro ao carregar filtros', e)
        alert('Erro ao carregar filtros. Tente novamente.')
      }
    },

    async carregarAberturas() {
      console.log('Iniciando carregarAberturas')
      this.loading = true
      try {
        const url = new URL(this.listaEndpoint, window.location.href)

        Object.entries(this.filters).forEach(([k, v]) => {
          if (k === 'periodo') return
          if (v !== null && v !== '' && v !== undefined) {
            url.searchParams.set(k, v)
          }
        })

        url.searchParams.set('page', this.currentPage)
        url.searchParams.set('limit', this.itemsPerPage)

        console.log('Buscando aberturas com URL:', url.toString())

        const res = await fetch(url)
        const json = await res.json()

        this.aberturas = json.data ?? []
        this.total = json.total ?? 0

        console.log('Aberturas carregadas:', this.aberturas.length, 'Total:', this.total)

        if (!this.setores.length && json.setores?.length) this.setores = json.setores
        if (!this.chefes.length && json.chefes?.length) this.chefes = json.chefes

        if (this.total === 0) {
          console.warn('Nenhum registro encontrado para os filtros selecionados')
          alert('Nenhum registro encontrado para os filtros selecionados.')
        }

      } catch (e) {
        console.error('Erro ao carregar aberturas', e)
        alert('Erro ao carregar dados. Tente novamente.')
      } finally {
        console.log('Finalizando carregarAberturas, loading:', this.loading)
        this.loading = false
      }
    },

    onOptionsChange({ page, itemsPerPage: ipp }) {
      this.currentPage = page
      this.itemsPerPage = ipp
      this.carregarAberturas()
    },

    buscar() {
      this.currentPage = 1
      this.carregarAberturas()
    },

    limparBusca() {
      this.filters = {
        id: '', setor_id: null, chefe_id: null,
        periodo: null, data_inicio: '', data_fim: ''
      }
      this.currentPage = 1
      this.aberturas = []
      this.total = 0
      this.ultimaSelecao = null
      this.carregarFiltros()
    },

    onPeriodoChange(value) {
      if (!value) {
        this.filters.data_inicio = ''
        this.filters.data_fim = ''
        return
      }

      if (value === 'custom') {
        this.dialogPeriodo = true
        return
      }

      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)
      const fmt = d => d.toISOString().split('T')[0]

      let ini = new Date(hoje)
      let fim = new Date(hoje)

      switch (value) {
        case 'ontem':
          ini.setDate(hoje.getDate() - 1)
          fim.setDate(hoje.getDate() - 1)
          break
        case 'semana_atual':
          ini.setDate(hoje.getDate() - hoje.getDay())
          break
        case 'semana_passada':
          ini.setDate(hoje.getDate() - hoje.getDay() - 7)
          fim.setDate(hoje.getDate() - hoje.getDay() - 1)
          break
        case '15_dias':
          ini.setDate(hoje.getDate() - 15)
          break
        case 'mes_atual':
          ini = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
          break
      }

      this.filters.data_inicio = fmt(ini)
      this.filters.data_fim = fmt(fim)
      this.currentPage = 1
    },

    aplicarPeriodoCustom() {
      if (!this.periodoCustom.data_inicio || !this.periodoCustom.data_fim) return
      this.filters.data_inicio = this.periodoCustom.data_inicio
      this.filters.data_fim = this.periodoCustom.data_fim
      this.currentPage = 1
      this.dialogPeriodo = false
      this.carregarAberturas()
    },

    formatDate(value) {
      if (!value) return '—'
      const d = new Date(value.length === 10 ? value + 'T00:00:00' : value)
      if (isNaN(d.getTime())) return value
      return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
    },

    getStatusColor(status) {
      if (!status) return 'default'
      const s = status.toUpperCase()
      if (s.includes('ABERTO')) return 'success'
      if (s.includes('ENCERR')) return 'error'
      return 'info'
    }
  },

  mounted() {
    console.log('RelatorioFiltroOriginal montado!')
    console.log('Loading inicial:', this.loading)
    
    this.carregarFiltros()
    
    // Carregar dados de hoje por padrão
    this.filters.periodo = 'hoje'
    console.log('Filtros definidos, carregando aberturas...')
    
    this.carregarAberturas()
    
    console.log('Mounted finalizado, loading:', this.loading)
  }
}
</script>

<style scoped>
/* ── Variáveis ─────────────────────────────────────── */
:root {
  --accent: #2563eb;
  --accent-soft: #dbeafe;
  --accent-strong: #1d4ed8;
  --rose-bg: #fef2f2;
  --rose-border: #fca5a5;
  --rose-text: #dc2626;
  --heading: #1e293b;
  --text: #475569;
  --muted: #94a3b8;
  --card-bg: #ffffff;
  --filter-bg: #f8fafc;
  --border: #e2e8f0;
  --table-row: #f8fafc;
  --hover-row: #eef2ff;
}

*, *::before, *::after { box-sizing: border-box; }

body {
  margin: 0;
  min-height: 100vh;
  font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;
  background: linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%);
  color: var(--text);
}

[v-cloak] { display: none; }
.mono { font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 0.82rem; }

/* ── Page wrap ─────────────────────────────────────── */
.page-wrap {
  max-width: 1400px;
  margin: 0 auto;
  padding: 28px 20px;
}

/* ── Header card ─────────────────────────────────────── */
.header-card {
  background: var(--card-bg);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(37,99,235,.11), 0 1px 4px rgba(37,99,235,.06);
  padding: 22px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.header-left { display: flex; align-items: center; gap: 12px; }

.header-icon {
  width: 46px; height: 46px;
  background: var(--accent-soft);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.page-title {
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  font-weight: 700;
  color: var(--heading);
  margin: 0 0 2px;
  line-height: 1.2;
}

.page-date {
  font-size: 0.78rem;
  color: var(--muted);
  display: flex; align-items: center; gap: 4px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.stat-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--filter-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 8px 14px;
  min-width: 130px;
}

.stat-pill-icon {
  width: 32px; height: 32px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.stat-pill-icon.blue { background: #dbeafe; }
.stat-pill-icon.purple { background: #ede9fe; }
.stat-pill-icon.teal { background: #cffafe; }

.stat-pill-body { display: flex; flex-direction: column; line-height: 1.2; }

.stat-pill-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
}

.stat-pill-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--heading);
}

.stat-pill-value.small {
  font-size: 0.75rem;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
  color: var(--text);
}

/* ── Filters card ──────────────────────────────────── */
.filters-card {
  background: var(--filter-bg);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px 22px;
  margin-bottom: 18px;
}

.filters-title {
  display: flex; align-items: center; gap: 7px;
  font-size: 0.85rem; font-weight: 600;
  color: var(--heading);
  margin-bottom: 14px;
}

/* ── Table card ──────────────────────────────────── */
.table-card {
  background: var(--card-bg);
  border-radius: 16px;
  border: 1px solid var(--border);
  box-shadow: 0 4px 24px rgba(15,23,42,.07);
  overflow: hidden;
}

/* ── Vuetify overrides ─────────────────────────────── */
.v-application { background: transparent !important; }

.v-btn:not(.v-btn--icon) {
  box-shadow: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
}

.v-btn.btn-primary {
  background: var(--accent) !important;
  color: #fff !important;
  border: 1px solid var(--accent-strong) !important;
}
.v-btn.btn-primary:hover {
  background: var(--accent-strong) !important;
}

.v-btn.btn-secondary {
  background: var(--accent-soft) !important;
  color: var(--accent-strong) !important;
  border: 1px solid #bfdbfe !important;
}
.v-btn.btn-secondary:hover {
  background: var(--accent) !important;
  color: #fff !important;
}

.v-btn.btn-danger {
  background: var(--rose-bg) !important;
  color: var(--rose-text) !important;
  border: 1px solid var(--rose-border) !important;
}
.v-btn.btn-danger:hover {
  background: var(--rose-text) !important;
  color: #fff !important;
}

.btn-refresh { color: var(--accent) !important; }
.btn-back { color: #64748b !important; }
.btn-back:hover { color: var(--accent) !important; }

.v-field__outline { border-color: var(--border) !important; }
.v-field--focused .v-field__outline { border-color: var(--accent) !important; }
.v-label { color: var(--muted) !important; }
.v-label--active { color: var(--accent) !important; }
.v-field__input { color: var(--heading) !important; font-size: 0.88rem !important; }

.v-card { background: var(--card-bg) !important; color: var(--text) !important; }
.v-icon { color: var(--muted) !important; }
.v-overlay__scrim { background: rgba(15,23,42,.35) !important; }
.v-dialog .v-card { border-radius: 16px !important; border: 1px solid var(--border) !important; }

.v-chip { font-size: 0.75rem !important; font-weight: 600 !important; }

/* ── Vuetify table overrides ─────────────────────────────── */
.v-data-table thead th {
  background: var(--accent-soft) !important;
  color: var(--heading) !important;
  font-weight: 600 !important;
  font-size: 0.76rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.06em !important;
  padding: 13px 12px !important;
  border-bottom: 2px solid #bfdbfe !important;
}
.v-data-table tbody tr { background: var(--card-bg) !important; }
.v-data-table tbody tr:nth-child(even) { background: var(--table-row) !important; }
.v-data-table tbody tr:hover td { background: var(--hover-row) !important; }
.v-data-table tbody td {
  color: var(--text) !important;
  font-size: 0.85rem !important;
  padding: 8px 12px !important;
  border-bottom: 1px solid var(--border) !important;
  height: 44px !important;
}
.v-data-table tfoot td { background: #f8fafc !important; font-weight: 700 !important; }

/* ── Footer ────────────────────────────────────── */
.page-footer {
  text-align: center;
  margin-top: 16px;
  font-size: 0.78rem;
  color: var(--muted);
}

/* ── Responsivo ────────────────────────────────────── */
@media (max-width: 768px) {
  .header-card { flex-direction: column; align-items: flex-start; }
  .header-right { width: 100%; }
  .stat-pill { min-width: 0; flex: 1; }
}
</style>
